<template>
  <nuxt />
</template>

<script>
export default {
  name: 'Empty',
}
</script>
